import React, { useEffect, useState } from 'react'
import { Card, Row, Col, Avatar, Typography, Divider, Spin } from 'antd'
import { UserOutlined, PhoneOutlined, IdcardOutlined } from '@ant-design/icons'
import axiosInstance from '../Utils/axiosInstance'
import { GetUserProfileData, ImgPath } from "../API's/UserApi"

const { Title, Text } = Typography

const UserProfile = () => {
  const [profile, setProfile] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const mobileNo = sessionStorage.getItem('mobileNo')

    if (mobileNo) {
      getProfile(mobileNo)
    }
  }, [])

  const getProfile = async (mobileNo) => {
    try {
      const res = await axiosInstance.get(
        `${GetUserProfileData}?mobileNo=${mobileNo}`,
      )
      setProfile(res.data)
    } catch (err) {
      console.error(err)
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return (
      <div style={{ textAlign: 'center', marginTop: 100 }}>
        <Spin size="large" />
      </div>
    )
  }

  return (
    <div className="payment-container">
      <Card className="payment-card">
        <Title className="login-title" level={3} style={{ textAlign: 'start' }}>
          My Profile
        </Title>

        <Row gutter={[24, 24]} align="middle">
          <Col xs={24}></Col>

          <Col xs={24} md={6} style={{ textAlign: 'center' }}>
            <Avatar
              size={120}
              src={`${ImgPath}${profile.photo}`}
              icon={<UserOutlined />}
            />
            <Title level={4} style={{ marginTop: 10 }}>
              {profile.name}
            </Title>
            <Text type="secondary">{profile.userTypeName}</Text>
          </Col>

          {/* Profile Details */}
          <Col xs={24} md={18}>
            {/* <Divider orientation="left">Personal Information</Divider> */}

            <Row gutter={[16, 16]}>
              <Col xs={24} md={12}>
                <Text strong>Mobile Number</Text>
                <br />
                <Text>
                  <PhoneOutlined /> {profile.mobileNo}
                </Text>
              </Col>

              <Col xs={24} md={12}>
                <Text strong>Emergency Contact</Text>
                <br />
                <Text>{profile.emergencyMobNo}</Text>
              </Col>

              <Col xs={24} md={12}>
                <Text strong>Date of Birth</Text>
                <br />
                <Text>{profile.birthDate}</Text>
              </Col>

              <Col xs={24} md={12}>
                <Text strong>Gender</Text>
                <br />
                <Text>{profile.gender === 1 ? 'Male' : 'Female'}</Text>
              </Col>

              <Col xs={24} md={12}>
                <Text strong>Aadhaar Number</Text>
                <br />
                <Text>
                  <Text>
                    <IdcardOutlined />{' '}
                    {'*'.repeat(profile.aadhaarNo.length - 4) +
                      profile.aadhaarNo.slice(-4)}
                  </Text>
                </Text>
              </Col>

              <Col xs={24}>
                <Text strong>Address</Text>
                <br />
                <Text>{profile.address}</Text>
              </Col>
            </Row>
          </Col>
        </Row>
      </Card>
    </div>
  )
}

export default UserProfile
